import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { postarNaRota } from "@/hooks/useLeadsCarteira";

export type ProximoPasso = "ligar" | "whatsapp" | "proposta";

export interface NegacaoLead {
  quando: string | null;
  quem: string | null;
}

export function useNegacaoLead(leadId: string | null, ativo: boolean) {
  return useQuery({
    queryKey: ["lead-negacao", leadId],
    enabled: !!leadId && ativo,
    staleTime: 30_000,
    queryFn: async (): Promise<NegacaoLead> => {
      const { data, error } = await supabase
        .from("leads_carteira_historico")
        .select("created_at, usuario_id")
        .eq("lead_id", leadId as string)
        .eq("acao", "NEGADO")
        .order("created_at", { ascending: false })
        .limit(1);
      if (error) throw error;
      const ultimo = (data as { created_at: string; usuario_id: string | null }[] | null)?.[0];
      if (!ultimo) return { quando: null, quem: null };
      let quem: string | null = null;
      if (ultimo.usuario_id) {
        const { data: u } = await supabase.from("usuarios").select("nome").eq("id", ultimo.usuario_id).maybeSingle();
        quem = (u as { nome?: string } | null)?.nome ?? null;
      }
      return { quando: ultimo.created_at, quem };
    },
  });
}

export function useVoltarATrabalhar(leadId: string | null) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ motivo, proximo }: { motivo: string; proximo: ProximoPasso }) =>
      postarNaRota(`/v1/leads-carteira/${leadId}/voltar-a-trabalhar`, { motivo, proximo }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lead-negacao", leadId] });
      queryClient.invalidateQueries({ queryKey: ["lead-historico"] });
    },
  });
}
